<div class="image-cropper-container">
  <div class="cropper-header">
    <h3>Recadrer votre photo</h3>
    <p>
      Déplacez et ajustez la zone de recadrage pour obtenir un carré parfait
    </p>
  </div>

  <div class="cropper-canvas-container" *ngIf="imageLoaded">
    <canvas
      #canvas
      class="cropper-canvas"
      (mousedown)="onMouseDown($event)"
      (mousemove)="onMouseMove($event)"
      (mouseup)="onMouseUp()"
      (mouseleave)="onMouseUp()"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd($event)"
      (wheel)="onWheel($event)">
    </canvas>
  </div>

  <div class="cropper-loading" *ngIf="!imageLoaded">
    <p-progressBar
      mode="indeterminate"
      [style]="{ height: '4px' }"></p-progressBar>
    <p>Chargement de l'image...</p>
  </div>

  <div class="cropper-error" *ngIf="imageError">
    <i class="pi pi-exclamation-triangle"></i>
    <p>Erreur lors du chargement de l'image</p>
  </div>

  <div class="cropper-instructions">
    <p>
      <i class="pi pi-info-circle"></i>
      <span class="desktop-text">Utilisez la molette pour zoomer/dézoomer</span>
      <span class="mobile-text">Glissez pour repositionner</span>
    </p>
  </div>

  <div class="cropper-actions">
    <p-button
      label="Annuler"
      icon="pi pi-times"
      styleClass="outline"
      (onClick)="cancel()">
    </p-button>
    <p-button
      label="Valider"
      icon="pi pi-check"
      (onClick)="crop()"
      [disabled]="!imageLoaded">
    </p-button>
  </div>
</div>
